import {
  ComponentParams,
  ComponentRendering,
  ImageField,
  Field,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';

export interface C43MediaGalleryItemProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: C43MediaGalleryItemFields;
}

export interface C43MediaGalleryItemFields {
  Image?: ImageField;
  VideoID?: Field<string>;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
}
